import React from 'react';
import { createFileRoute } from '@tanstack/react-router';
import { EmptyView, withTranslation } from '@piwikpro/ui-components';

const AppsEmpty = withTranslation('administration')(({ t }: any) => (
  <EmptyView text={t('apps.list.emptyMessage')} />
));

export const Route = createFileRoute('/_secured/administration/apps/')({
  component: AppsEmpty,
});
